import React from 'react';

import { withCommon } from '../../../../components';
import { API_PREFIX } from '../../../../common/api/api-url-config';
import apiUrls from '../../../../common/api/api-urls';

const Zoom = withCommon({
    store: ({ store }) => ({
        viewSize: store.site.status.viewSize,
    }),
    defaultName: 'ZoomPage',
    isObserver: true,
})(({ viewSize }) => {
    return (
        <div className={`ll-page tvbet--${viewSize}`}>
            <iframe
                className={`tvbet-iframe--${viewSize}`}
                title="tvbet"
                src={`${API_PREFIX}${apiUrls.games.openGame}?providerId=900`}
                frameBorder="0"
                allowFullScreen
            />
        </div>
    );
});

export default Zoom;
